import React from "react";

import {
  Box,
  Button,
  Drawer,
  Typography,
  Toolbar,
} from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentsIcon from "@mui/icons-material/Payments";
import PersonIcon from "@mui/icons-material/Person";

import {
  useNavigate,
  useLocation,
} from "react-router-dom";

import { useAuth } from "../context/AuthContext";

const drawerWidth = 240;

export default function Sidebar({
  mobileOpen,
  setMobileOpen,
}) {
  const navigate = useNavigate();

  const location = useLocation();

  const { logout } = useAuth();

  const menuItems = [
    {
      label: "Dashboard",
      path: "/dashboard",
      icon: <DashboardIcon />,
    },
    {
      label: "Menu",
      path: "/menu",
      icon: <RestaurantMenuIcon />,
    },
    {
      label: "Orders",
      path: "/orders",
      icon: <ReceiptLongIcon />,
    },
    {
      label: "Financial",
      path: "/financial",
      icon: <PaymentsIcon />,
    },
    {
      label: "Account",
      path: "/account",
      icon: <PersonIcon />,
    },
  ];

  const drawerContent = (
    <Box
      sx={{
        height: "100%",
        bgcolor: "#1E1E2F",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        p: 2,
      }}
    >
      {/* LOGO */}
      <Typography
        variant="h5"
        fontWeight={700}
        mb={4}
      >
        Mealno Vendor
      </Typography>

      {/* MENU */}
      <Box sx={{ flex: 1 }}>
        {menuItems.map((item) => {
          const active =
            location.pathname === item.path;

          return (
            <Button
              key={item.path}
              fullWidth
              startIcon={item.icon}
              onClick={() => {
                navigate(item.path);

                if (setMobileOpen) {
                  setMobileOpen(false);
                }
              }}
              sx={{
                justifyContent: "flex-start",
                mb: 1,
                px: 2,
                py: 1.5,
                borderRadius: 3,

                color: active
                  ? "#FF4B2B"
                  : "#fff",

                bgcolor: active
                  ? "rgba(255,255,255,0.08)"
                  : "transparent",

                fontWeight: 600,

                textTransform: "none",

                "&:hover": {
                  bgcolor:
                    "rgba(255,255,255,0.08)",
                },
              }}
            >
              {item.label}
            </Button>
          );
        })}
      </Box>

      {/* LOGOUT */}
      <Button
        fullWidth
        variant="contained"
        color="error"
        onClick={logout}
        sx={{
          borderRadius: 3,
          py: 1.2,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Logout
      </Button>
    </Box>
  );

  return (
    <>
      {/* MOBILE DRAWER */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() =>
          setMobileOpen(false)
        }
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: {
            xs: "block",
            md: "none",
          },

          "& .MuiDrawer-paper": {
            width: drawerWidth,
            border: "none",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* DESKTOP SIDEBAR */}
      <Drawer
        variant="permanent"
        open
        sx={{
          display: {
            xs: "none",
            md: "block",
          },

          width: drawerWidth,

          flexShrink: 0,

          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            border: "none",
          },
        }}
      >
        <Toolbar
          sx={{
            minHeight: "70px !important",
          }}
        />

        {drawerContent}
      </Drawer>
    </>
  );
}